import { useContext } from 'react';

import { MatchButtonGlobalsContext } from '../WidgetEventsManager';
import { ContentHeaderBar } from './ContentHeaderBar';

export const MatchContentHeaderBar = () => {
  const { setMatchButtonOpen, matchButtonOpen } = useContext(MatchButtonGlobalsContext);
  return <ContentHeaderBar open={matchButtonOpen} setOpen={setMatchButtonOpen} />;
};
